import { render, staticRenderFns } from "./done.vue?vue&type=template&id=6e590f8e&scoped=true&"
import script from "./done.vue?vue&type=script&lang=js&"
export * from "./done.vue?vue&type=script&lang=js&"
import style0 from "./done.vue?vue&type=style&index=0&id=6e590f8e&scoped=true&lang=css&"
import style1 from "./done.vue?vue&type=style&index=1&id=6e590f8e&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e590f8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e590f8e')) {
      api.createRecord('6e590f8e', component.options)
    } else {
      api.reload('6e590f8e', component.options)
    }
    module.hot.accept("./done.vue?vue&type=template&id=6e590f8e&scoped=true&", function () {
      api.rerender('6e590f8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/supervision/recommend/components/done.vue"
export default component.exports